import { apiInstance } from "shared/api";
import {
  CheckSignPersonalDataBody,
  CheckSignPersonalDataResponse,
  GetPersonalDataResponse,
  SignPersonalDataResponse,
} from "./types";

export const getPersonalData = (): Promise<GetPersonalDataResponse> => {
  return apiInstance.get(`/v1/personal-data`).then((response) => response.data);
};

export const signPersonalDataById = (
  id: string,
  params?: { provider: string },
): Promise<SignPersonalDataResponse> =>
  apiInstance
    .post(`/v1/personal-data/${id}/sign`, params)
    .then((response) => response.data);

export const checkSignPersonalDataById = (
  id: string,
  params: CheckSignPersonalDataBody,
): Promise<CheckSignPersonalDataResponse> =>
  apiInstance
    .post(`/v1/personal-data/${id}/sign-check`, params)
    .then((response) => response.data);

export const getPersonalDataPdfById = (id: string): Promise<Blob> =>
  apiInstance
    .get(`/v1/personal-data/${id}/download`, {
      responseType: "blob",
    })
    .then((response) => response.data);

export const downloadPersonalDataById = (id: string): Promise<Blob> =>
  apiInstance
    .get(`/v1/personal-data/${id}/download-archive`, {
      responseType: "blob",
    })
    .then((response) => response.data);
